import { createSelector } from 'reselect';
import { RootState } from '../../../../types';
import { EntityTypes } from '../../../../constants/entities';
import { IKeyArray } from 'types/IKeyArray';
import { assetId, AssetType, IAsset } from 'types/app/asset';
import { ISceneDAO } from 'types/domain/scene';
import { selectScene } from './scene';

const scene = selectScene;
const assets = (state: RootState, id?) => state.core.assets;

const parseSceneAsset = (scene: ISceneDAO, assets: IKeyArray<IAsset>): IAsset | null => {
  if (!scene) return null;
  if (scene.video) return assets[assetId(EntityTypes.SCENE, scene.id, AssetType.VIDEO, scene.video.id)];
  if (scene.image) return assets[assetId(EntityTypes.SCENE, scene.id, AssetType.IMAGE, scene.image.id)];
  if (scene.model) return assets[assetId(EntityTypes.SCENE, scene.id, AssetType.MODEL, scene.model.id)];
  return null;
};

export const selectSceneAsset = createSelector([scene, assets], parseSceneAsset);

const voiceScene = (state: RootState, sceneId: number, voiceSceneId?: number) =>
  voiceSceneId ? (state.entity.present[EntityTypes.SCENE][voiceSceneId] as ISceneDAO) : null;

const parseVoiceSceneAsset = (voiceScene: ISceneDAO, assets: IKeyArray<IAsset>): IAsset | null => {
  if (!voiceScene) return null;
  if (voiceScene.video) return assets[assetId(EntityTypes.SCENE, voiceScene.id, AssetType.VIDEO, voiceScene.video.id)];
  return null;
};

export const selectVoiceSceneAsset = createSelector([voiceScene, assets], parseVoiceSceneAsset);
